import { SavedSearchRequest } from '@doda/api-client/aspida/@types';
import { SelectedCurrentConditionType } from 'types/searchCondition';

/**
 * TODO:保存した検索条件APIや求人件数取得APIなどのリクエストボディの各パラメータがAPIごとに違う。また、stringやnumberなどで微妙に違いがあるのでコードを簡潔に書くためにもAPIのリクエストパラメータ名や型は揃えたい。
 *TODO: リファクタ時に登録変更画面と共通化（可能であればサイドバーとも共通化を検討）
 * 現在選択されている検索条件を保存した検索条件APIリクエストパラメータの形に成形
 * @param {SelectedCurrentConditionType} selectedCurrentCondition 現在選択されている検索条件
 * @param {string} conditionNameValue 検索条件名
 * @returns {SavedSearchRequest} 保存した検索条件リクエストパラメータ
 */
export const createSavedConditionParams = (
  selectedCurrentCondition: SelectedCurrentConditionType,
  conditionNameValue: string
) => {
  const requestParams: SavedSearchRequest = {
    name: conditionNameValue,
  };
  if (selectedCurrentCondition.areaId?.length) {
    requestParams.areaIdList = selectedCurrentCondition.areaId.map(Number);
  }
  if (selectedCurrentCondition.prefectureId?.length) {
    requestParams.prefectureIdList =
      selectedCurrentCondition.prefectureId?.map(Number);
  }
  if (selectedCurrentCondition.cityId?.length) {
    requestParams.cityIdList = selectedCurrentCondition.cityId;
  }
  if (selectedCurrentCondition.wardId?.length) {
    requestParams.wardIdList = selectedCurrentCondition.wardId;
  }
  if (selectedCurrentCondition.routeId?.length) {
    requestParams.routeIdList = selectedCurrentCondition.routeId;
  }
  if (selectedCurrentCondition.stationId?.length) {
    requestParams.stationIdList = selectedCurrentCondition.stationId;
  }
  if (selectedCurrentCondition.searchJobTypeLId?.length) {
    requestParams.searchJobTypeLIdList =
      selectedCurrentCondition.searchJobTypeLId;
  }
  if (selectedCurrentCondition.searchJobTypeMId?.length) {
    requestParams.searchJobTypeMIdList =
      selectedCurrentCondition.searchJobTypeMId;
  }
  if (selectedCurrentCondition.searchJobTypeSId?.length) {
    requestParams.searchJobTypeSIdList =
      selectedCurrentCondition.searchJobTypeSId;
  }
  if (selectedCurrentCondition.industryLId?.length) {
    requestParams.industryLIdList = selectedCurrentCondition.industryLId;
  }
  if (selectedCurrentCondition.industrySId?.length) {
    requestParams.industrySIdList = selectedCurrentCondition.industrySId;
  }
  if (selectedCurrentCondition.includedKeywordCategory) {
    requestParams.includedKeywordCategory =
      selectedCurrentCondition.includedKeywordCategory;
  }
  if (selectedCurrentCondition.includedKeyword?.length) {
    requestParams.includedKeywordList =
      selectedCurrentCondition.includedKeyword;
  }
  if (selectedCurrentCondition.excludedKeywordCategory) {
    requestParams.excludedKeywordCategory =
      selectedCurrentCondition.excludedKeywordCategory;
  }
  if (selectedCurrentCondition.excludedKeyword?.length) {
    requestParams.excludedKeywordList =
      selectedCurrentCondition.excludedKeyword;
  }
  if (selectedCurrentCondition.isNewArrival) {
    requestParams.isNewArrival = selectedCurrentCondition.isNewArrival;
  }
  if (selectedCurrentCondition.isNearDeadline) {
    requestParams.isNearDeadline = selectedCurrentCondition.isNearDeadline;
  }
  if (selectedCurrentCondition.employmentStatus?.length) {
    requestParams.employmentStatusList =
      selectedCurrentCondition.employmentStatus;
  }
  if (selectedCurrentCondition.holidayAndWayOfWorking?.length) {
    requestParams.holidayAndWayOfWorkingList =
      selectedCurrentCondition.holidayAndWayOfWorking;
  }
  if (selectedCurrentCondition.requirements?.length) {
    requestParams.requirementsList = selectedCurrentCondition.requirements;
  }
  if (selectedCurrentCondition.workplaceEnvironment?.length) {
    requestParams.workplaceEnvironmentList =
      selectedCurrentCondition.workplaceEnvironment;
  }
  if (selectedCurrentCondition.welfareBenefits?.length) {
    requestParams.welfareBenefitsList =
      selectedCurrentCondition.welfareBenefits;
  }
  if (selectedCurrentCondition.languageSkills?.length) {
    requestParams.languageSkillsList = selectedCurrentCondition.languageSkills;
  }
  if (selectedCurrentCondition.positions?.length) {
    requestParams.positionsList = selectedCurrentCondition.positions;
  }
  if (selectedCurrentCondition.employeeAverageAge?.length) {
    requestParams.employeeAverageAgeList =
      selectedCurrentCondition.employeeAverageAge;
  }
  if (selectedCurrentCondition.establish?.length) {
    requestParams.establishList = selectedCurrentCondition.establish;
  }
  if (selectedCurrentCondition.employNum?.length) {
    requestParams.employNumList = selectedCurrentCondition.employNum;
  }
  if (selectedCurrentCondition.lowerLimitIncome) {
    requestParams.lowerLimitIncome = selectedCurrentCondition.lowerLimitIncome;
  }
  if (selectedCurrentCondition.upperLimitIncome) {
    requestParams.upperLimitIncome = selectedCurrentCondition.upperLimitIncome;
  }
  if (selectedCurrentCondition.jobOfferKind) {
    requestParams.jobOfferKind = selectedCurrentCondition.jobOfferKind;
  }
  return requestParams;
};
